module.exports = __webpack_public_path__ + "img/ring_g_i_null_null@2x.fe03517d.png";